import {
  getRangesForDay,
  hhmmToMinutes,
  type DayIndex,
  type ServiceDisplayDayPart,
} from '../day-part/utils';
import type { DayPartThreshold } from './types';

export interface NowForDayPart {
  dayIndex: DayIndex;
  minutesSinceMidnight: number;
}

export type ResolvedThresholdType = 'COUNT' | 'TIME';

/**
 * Returns the threshold value for the currently active day part, or fallback if none applies.
 * Active = current day and time falls within that day part's schedule range.
 */
export function getResolvedThreshold(
  thresholds: readonly DayPartThreshold[],
  allDayParts: readonly ServiceDisplayDayPart[],
  now: NowForDayPart,
  fallback: number,
  type: ResolvedThresholdType,
): number {
  if (!thresholds?.length || !allDayParts?.length) return fallback;

  for (const t of thresholds) {
    if (t.type !== type) continue;
    const dp = allDayParts.find((d) => d.id === t.dayPartsId);
    if (!dp) continue;
    const ranges = getRangesForDay(dp.dayParts, now.dayIndex);
    if (ranges.length === 0) continue;
    const start = hhmmToMinutes(ranges[0].start);
    const end = hhmmToMinutes(ranges[0].end);
    if (now.minutesSinceMidnight >= start && now.minutesSinceMidnight < end) return t.threshold;
  }
  return fallback;
}
